function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* global window */

/**
 * @module ckfinder/ckfindercommand
 */
import { Command } from 'ckeditor5/src/core';
import { CKEditorError } from 'ckeditor5/src/utils';
/**
 * The CKFinder command. It is used by the {@link module:ckfinder/ckfinderediting~CKFinderEditing CKFinder editing feature}
 * to open the CKFinder file manager to insert an image or a link to a file into the editor content.
 *
 *		editor.execute( 'ckfinder' );
 *
 * **Note:** This command uses other features to perform tasks:
 * - To insert images the {@link module:image/image/insertimagecommand~InsertImageCommand 'insertImage'} command
 * from the {@link module:image/image~Image Image feature}.
 * - To insert links to files the {@link module:link/linkcommand~LinkCommand 'link'} command
 * from the {@link module:link/link~Link Link feature}.
 *
 * @extends module:core/command~Command
 */

var CKFinderCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(CKFinderCommand, _Command);

  /**
   * @inheritDoc
   */
  function CKFinderCommand(editor) {
    var _this;

    _classCallCheck(this, CKFinderCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CKFinderCommand).call(this, editor)); // Remove default document listener to lower its priority.

    _this.stopListening(_this.editor.model.document, 'change'); // Lower this command listener priority to be sure that refresh() will be called after link & image refresh.


    _this.listenTo(_this.editor.model.document, 'change', function () {
      return _this.refresh();
    }, {
      priority: 'low'
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CKFinderCommand, [{
    key: "refresh",
    value: function refresh() {
      var imageCommand = this.editor.commands.get('insertImage');
      var linkCommand = this.editor.commands.get('link'); // The CKFinder command is enabled when one of image or link command is enabled.

      this.isEnabled = imageCommand.isEnabled || linkCommand.isEnabled;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var editor = this.editor;
      var openerMethod = this.editor.config.get('ckfinder.openerMethod') || 'modal';

      if (openerMethod != 'popup' && openerMethod != 'modal') {
        /**
         * The `ckfinder.openerMethod` must be one of: "popup" or "modal".
         *
         * @error ckfinder-unknown-openermethod
         */
        throw new CKEditorError('ckfinder-unknown-openermethod', editor);
      }

      var options = this.editor.config.get('ckfinder.options') || {};
      options.chooseFiles = true; // Cache the user-defined onInit method

      var originalOnInit = options.onInit; // Pass the lang code to the CKFinder if not defined by user.

      if (!options.language) {
        options.language = editor.locale.uiLanguage;
      } // The onInit method allows to extend CKFinder's behavior. It is used to attach event listeners to file choosing related events.


      options.onInit = function (finder) {
        // Call original options.onInit if it was defined by user.
        if (originalOnInit) {
          originalOnInit(finder);
        }

        finder.on('files:choose', function (evt) {
          var files = evt.data.files.toArray(); // Insert links

          var links = files.filter(function (file) {
            return !file.isImage();
          });
          var images = files.filter(function (file) {
            return file.isImage();
          });
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var linkFile = _step.value;
              editor.execute('link', linkFile.getUrl());
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var imagesUrls = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = images[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var image = _step2.value;
              var url = image.getUrl();
              imagesUrls.push(url ? url : finder.request('file:getProxyUrl', {
                file: image
              }));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (imagesUrls.length) {
            insertImages(editor, imagesUrls);
          }
        });
        finder.on('file:choose:resizedImage', function (evt) {
          var resizedUrl = evt.data.resizedUrl;

          if (!resizedUrl) {
            var notification = editor.plugins.get('Notification');
            var t = editor.locale.t;
            notification.showWarning(t('Could not obtain resized image URL.'), {
              title: t('Selecting resized image failed'),
              namespace: 'ckfinder'
            });
            return;
          }

          insertImages(editor, [resizedUrl]);
        });
      };

      window.CKFinder[openerMethod](options);
    }
  }]);

  return CKFinderCommand;
}(Command);

export { CKFinderCommand as default };

function insertImages(editor, urls) {
  var imageCommand = editor.commands.get('insertImage'); // Check if inserting an image is actually possible - it might be possible to only insert a link.

  if (!imageCommand.isEnabled) {
    var notification = editor.plugins.get('Notification');
    var t = editor.locale.t;
    notification.showWarning(t('Could not insert image at the current position.'), {
      title: t('Inserting image failed'),
      namespace: 'ckfinder'
    });
    return;
  }

  editor.execute('insertImage', {
    source: urls
  });
}